export const hayPrimas = (data) => data.filter((f)=> f.prima!==0).length>0;
export const hayFiniquito = (data) => data.filter((f)=> f.finiquito!==0).length>0; 

export const getDynamicColumns_DetalleEmpleado = (verPrimas,verFiniquito,tipoEmpresa)=>{
  let columns = ["auto","auto","*","*","*","*","*","*"];

  columns = (tipoEmpresa.tipo==='S' || tipoEmpresa.subTipo==='S') ? [...columns, ...["*","*"]] : columns; //Columnas SS_Empleado y SalarioNeto
  columns = verPrimas===true ? [...columns, "*"] : columns; //Columna Prima
  columns = verFiniquito===true ? [...columns, "*"] : columns; //Columna Finiquito

  return columns;
}

export const getDynamicColumns_DetalleCentroCosto = (verPrimas,verFiniquito,esSucursal)=>{
  let columns = ["auto","*","*","*","*","*","*"];

  columns = esSucursal ? [...columns, ...["*","*"]] : columns; //Columnas SS_Empleado y SalarioNeto
  columns = verPrimas===true ? [...columns, "*"] : columns;
  columns = verFiniquito===true ? [...columns, "*"] : columns;

  return columns;
}

// export const getDynamicColumns_DetalleCentroCostoSucursal = (verPrimas,verFiniquito)=>{
//   let columns = ["auto","*","*","*","*","*","*","*","*"];

//   columns = verPrimas===true ? [...columns, "*"] : columns;
//   columns = verFiniquito===true ? [...columns, "*"] : columns;

//   return columns;
// }